module.exports = __webpack_public_path__ + "img/carousel-3.bdf0397e.png";